import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { map_style } from './inc/map-style.mjs';

let _clusters;

const default_icon = {
	url: '/app/themes/storm-theme/dist/images/map-marker.svg',
	anchor: new google.maps.Point(25, 50),
	scaledSize: new google.maps.Size(50, 50),
};

// create render method
const renderer = {
	render: ({ count, position }) => {
		const svg = window.btoa(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" xml:space="preserve"><circle cx="25" cy="25" r="25" stroke="#212c55" stroke-width="10" fill="#ffd425"/></svg>`);

		// create marker using svg icon
		return new google.maps.Marker({
			position,
			icon: {
				url: `data:image/svg+xml;base64,${svg}`,
				scaledSize: new google.maps.Size(30, 30),
			},
			label: {
				text: String(count),
				color: 'rgba(34,44,85,0.9)',
				fontSize: '14px',
				className: 'cluster-marker',
			},
		});
	},
};

function initMap(mapEl, markerEls) {
	// Create gerenic map.
	var mapArgs = {
		zoom: 2,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		styles: map_style,
		fullscreenControl: false,
		streetViewControl: false,
		mapTypeControl: false,
		center: new google.maps.LatLng(32.47351874545096, 30.672906250000022),
		maxZoom: 9,
	};

	const map = new google.maps.Map(mapEl, mapArgs);

	const infoWindow = new google.maps.InfoWindow({
		content: '',
		// disableAutoPan: true,
	});

	let markers = [];
	markerEls.forEach((markerEl) => {
		let type = markerEl.dataset.type;
		let type_array = type.split(',');
		let marker = new google.maps.Marker({
			position: {
				lat: parseFloat(markerEl.dataset.lat),
				lng: parseFloat(markerEl.dataset.lng),
			},
			icon: default_icon,
			map: map,
			type: type_array,
		});

		marker.addListener('click', () => {
			infoWindow.setContent(markerEl.innerHTML);
			infoWindow.open(map, marker);
		});

		marker.addListener('mouseover', () => {
			infoWindow.setContent(markerEl.innerHTML);
			infoWindow.open(map, marker);
		});

		marker.addListener('mouseout', () => {
			infoWindow.close();
		});

		markers.push(marker);

		// return marker;
	});

	let _clusters = new MarkerClusterer({ map, markers, renderer });

	// // On filter change
	document.querySelector('#filter-type').addEventListener('change', function (eventy) {
		// run the filter passing teh map and type value
		_clusters.clearMarkers();
		// _clusters.setMap(null);
		filterDataCentres(map, this.value, markers, _clusters);
	});

	function filterDataCentres(map, filter_value, markers, _clusters) {
		if (filter_value == '*') {
			// show all markers
			markers.forEach(function (marker, i) {
				markers[i].setVisible(true);
				// map.markers[i].setAnimation(4);
			});
		} else {
			markers.forEach(function (marker, i) {
				// Show/Hide matching marker type by filter value
				if (marker.type.includes(filter_value)) {
					markers[i].setVisible(true);
					// map.markers[i].setAnimation(4);
				} else {
					markers[i].setVisible(false);
				}
			});
		}
		_clusters = new MarkerClusterer({ map, markers, renderer });
	}
	return map;
}

initMap(document.getElementById('data-centres-map'), document.querySelectorAll('.marker'));
